import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zip",
  "use": "icon-zip-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-zip\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10.89,10.83H12V12H10.89ZM12,9.67h1.11v1.16H12ZM10.89,8.5H12V9.67H10.89ZM12,7.33h1.11V8.5H12ZM13.11,12v2.92H10.89V13.17H12V12Zm2.78,4.67V7.33H8.11v9.34Zm.55,1.16H7.56A.57.57,0,0,1,7,17.25V6.75a.57.57,0,0,1,.56-.58h8.88a.57.57,0,0,1,.56.58v10.5A.57.57,0,0,1,16.44,17.83Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol